import React from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '../../../common/Icons/CloseIcon'

import styles from './index.module.scss'

export default function MobileFiltersMenu(props) {
    if (typeof document !== 'object') return <div className={cn(styles.menu)}></div>

    return ReactDOM.createPortal(
        <div className={cn(styles.menu)}>
            <IconButton
                onClick={props.closeMenu}
                className={styles.closeButton}
                size="small"
            >
                <CloseIcon />
            </IconButton>
            {props.children}
        </div>,
        document.querySelector('.store-menu')
    )
}
